import { Pipe, PipeTransform } from '@angular/core';
import { Plugin } from 'src/app/services/dtos/plugin';

@Pipe({
  name: 'sortPluginsByName',
  pure: false
})
export class SortPluginsByNamePipe implements PipeTransform {
  public transform(plugins: Plugin[]): Plugin[] {
    if (plugins.length <= 1) {
      return [];
    }

    return plugins.slice().sort((pluginA, pluginB) => {
      const nameA = pluginA.displayName ? pluginA.displayName : pluginA.friendlyName;
      const nameB = pluginB.displayName ? pluginB.displayName : pluginB.friendlyName;

      return nameA.localeCompare(nameB);
    });
  }
}
